import { render, staticRenderFns } from "./Enquiry.vue?vue&type=template&id=1c31295e&scoped=true&"
import script from "./Enquiry.vue?vue&type=script&lang=js&"
export * from "./Enquiry.vue?vue&type=script&lang=js&"
import style0 from "./Enquiry.vue?vue&type=style&index=0&id=1c31295e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31295e",
  null
  
)

export default component.exports
import {QPage,QBtn,QSlideTransition,QList,QItem,QItemSection,QAvatar,QItemLabel,QIcon,QSpace,QColor} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn,QSlideTransition,QList,QItem,QItemSection,QAvatar,QItemLabel,QIcon,QSpace,QColor})
